import { useState } from 'react';
import { t, getal } from '../i18n.js';

/**
 * Dag van de week tegen uur van de dag (VPN): wanneer er wordt ingelogd. Eén kleur van licht naar donker (de grootte,
 * geen stand), in vijf stappen, met een legenda eronder en het getal in de tooltip. Een leeg vak is de kaartkleur met
 * een rand, zodat nul en weinig niet op elkaar lijken.
 *
 * cellen: [{ dag: 1..7 (maandag eerst), uur: 0..23, n }].
 */
const DAGEN = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];
const STAPPEN = [0.18, 0.36, 0.56, 0.78, 1];

export default function Heatmap({ cellen, kleur = 'var(--cyan-ink)', eenheid, label }) {
  const [tip, zetTip] = useState(null);
  const n = (d, u) => cellen.find((c) => c.dag === d && c.uur === u)?.n ?? 0;
  const max = Math.max(1, ...cellen.map((c) => c.n));
  const stap = (v) => (v ? STAPPEN[Math.min(STAPPEN.length - 1, Math.floor((v / max) * STAPPEN.length - 1e-9))] : 0);
  return (
    <div className="heatmap" role="img" aria-label={label}>
      <div className="hm-rooster" onMouseLeave={() => zetTip(null)}>
        <span />
        {Array.from({ length: 24 }, (_, u) => <span key={u} className="hm-uur">{u % 3 === 0 ? String(u).padStart(2, '0') : ''}</span>)}
        {DAGEN.map((d, i) => (
          <div key={d} className="hm-rij">
            <span className="hm-dag">{t(d)}</span>
            {Array.from({ length: 24 }, (_, u) => {
              const v = n(i + 1, u);
              return <span key={u} className={`hm-vak${v ? '' : ' leeg'}`} style={v ? { background: kleur, opacity: stap(v) } : undefined}
                onMouseEnter={() => zetTip({ d, u, v })} />;
            })}
          </div>
        ))}
      </div>
      <div className="hm-voet">
        <span className="muted">{tip ? <><b>{t(tip.d)} {String(tip.u).padStart(2, '0')}:00–{String(tip.u + 1).padStart(2, '0')}:00</b> · {getal(tip.v)} {eenheid}</> : t('Wijs een vak aan voor het aantal')}</span>
        <span className="hm-schaal"><span className="muted">{t('weinig')}</span>
          {STAPPEN.map((o) => <i key={o} style={{ background: kleur, opacity: o }} />)}<span className="muted">{getal(max)}</span></span>
      </div>
    </div>
  );
}
